<div class="sidebar sidebar-collapse">
  <aside class="main-sidebar elevation-1 compact-scroll">
    <button
      type="button"
      class="sidebar-menubtn"
      data-bs-toggle="offcanvas"
      (click)="open(content)"
      aria-controls="mainsidebar"
    >
    <app-icons name="nineDot" [width]="24" [height]="24" color=""></app-icons>
    </button>

    <!-- overlay sidebar -->
    <ng-template #content let-offcanvas>
      <div class="offcanvas-header">
        <h5 class="offcanvas-title" id="offcanvasExampleLabel">
          <img src="assets/images/client.png" alt="Client Logo" />
        </h5>
        <button
          type="button"
          class="btn-close text-reset"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          (click)="offcanvas.dismiss('Cross click')"
        >
        <app-icons name="close" [width]="24" [height]="24"></app-icons>
        </button>
      </div>
      <div class="offcanvas-body" #drawerBody (click)="handleClick($event, offcanvas)" (keydown)="handleClick($event, offcanvas)">
        <nav class="mt-0" aria-label="Sidebar Navigation">
          <div class="section">
            <div class="menu-head">
              <p class="heading">DASHBOARD</p>
            </div>
            <ul
              class="nav nav-pills nav-sidebar flex-column"
              data-widget="treeview"
              data-accordion="false"
            >
              <li class="nav-item has-treeview">
                <a class="nav-link active">
                  <app-icons name="home" [width]="20" [height]="20" color="#377FEB"></app-icons>
                  <span class="menu-text">Agent Dashboard</span>
                </a>
              </li>
              <li class="nav-item has-treeview">
                <a class="nav-link">
                 <app-icons name="actionDashboard" [width]="20" [height]="20" color="#377FEB"></app-icons>
                  <span class="menu-text">Action Dashboard</span>
                </a>
              </li>
            </ul>
          </div>
          <div class="section">
            <div class="menu-head">
              <p class="heading">COACHING</p>
            </div>
            <ul
              class="nav nav-pills nav-sidebar flex-column"
              data-widget="treeview"
              data-accordion="false"
            >
              <li class="nav-item has-treeview">
                <a class="nav-link">
                 <app-icons name="coaching" [width]="20" [height]="20" color="#377FEB"></app-icons>
                  <span class="menu-text">Coaching</span>
                </a>
              </li>
              <li class="nav-item has-treeview">
                <a class="nav-link">
                 <app-icons name="coach" [width]="20" [height]="20" color="#377FEB"></app-icons>
                  <span class="menu-text">Coach Tactical Warehouse</span>
                </a>
              </li>
              <li class="nav-item has-treeview">
                <a class="nav-link">
                 <app-icons name="coachee" [width]="20" [height]="20" color="#377FEB"></app-icons>
                  <span class="menu-text">Coachee Tactical Warehouse</span>
                </a>
              </li>
            </ul>
          </div>
          <div class="section">
            <div class="menu-head">
              <p class="heading">MY UNIVERSE</p>
            </div>

            <ul
              class="nav nav-pills nav-sidebar flex-column"
              data-widget="treeview"
              data-accordion="false"
            >
              <li class="nav-item has-treeview">
                <a class="nav-link">
                 <app-icons name="evaluation" [width]="20" [height]="20" color="#377FEB"></app-icons>
                  <span class="menu-text">My Evaluation</span>
                </a>
              </li>
              <li class="nav-item has-treeview">
                <a class="nav-link">
                 <app-icons name="labels" [width]="20" [height]="20" color="#377FEB"></app-icons>
                  <span class="menu-text">Labels</span>
                </a>
              </li>
              <li class="nav-item has-treeview">
                <a class="nav-link">
                 <app-icons name="calls" [width]="20" [height]="20" color="#377FEB"></app-icons>
                  <span class="menu-text">Manage Good/Bad Call</span>
                </a>
              </li>
            </ul>
          </div>
          <div class="section">
            <div class="menu-head">
              <p class="heading">CONFIGURE</p>
            </div>

            <ul
              class="nav nav-pills nav-sidebar flex-column"
              data-widget="treeview"
              data-accordion="false"
            >
              <li class="nav-item has-treeview">
                <a class="nav-link">
                 <app-icons name="calls" [width]="20" [height]="20" color="#377FEB"></app-icons>
                  <span class="menu-text">Account Management</span>
                </a>
              </li>
              <li class="nav-item has-treeview">
                <a class="nav-link">
                 <app-icons name="groupUser" [width]="20" [height]="20" color="#377FEB"></app-icons>
                  <span class="menu-text">User Management</span>
                </a>
              </li>
              <li class="nav-item has-treeview">
                <a class="nav-link">
                 <app-icons name="settings" [width]="20" [height]="20" color="#377FEB"></app-icons>
                  <span class="menu-text">Settings</span>
                </a>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </ng-template>
    <!-- overlay sidebar end -->

    <!-- Sidebar -->
    <div
      tabindex="-1"
      id="mainsidebar"
      class="mainsidebar"
      aria-labelledby="mainsidebarLabel"
    >
      <div class="sidebar">
        <!-- Sidebar Menu -->
        <nav class="mt-0" aria-label="Sidebar Navigation">
          <div class="section">
            <div class="menu-head">
              <p class="dots">...</p>
            </div>
            <ul
              class="nav nav-pills nav-sidebar flex-column"
              data-widget="treeview"
              data-accordion="false"
            >
              <li class="nav-item has-treeview">
                <a class="nav-link active">
                  <app-icons name="home" [width]="20" [height]="20" color="#377FEB"></app-icons>
                </a>
              </li>
              <li class="nav-item has-treeview">
                <a class="nav-link">
                 <app-icons name="actionDashboard" [width]="20" [height]="20" color="#377FEB"></app-icons>
                </a>
              </li>
            </ul>
          </div>
          <div class="section">
            <div class="menu-head">
              <p class="dots">...</p>
            </div>
            <ul
              class="nav nav-pills nav-sidebar flex-column"
              data-widget="treeview"
              data-accordion="false"
            >
              <li class="nav-item has-treeview">
                <a class="nav-link">
                 <app-icons name="coaching" [width]="20" [height]="20" color="#377FEB"></app-icons>
                </a>
              </li>
              <li class="nav-item has-treeview">
                <a class="nav-link">
                 <app-icons name="coach" [width]="20" [height]="20" color="#377FEB"></app-icons>
                </a>
              </li>
              <li class="nav-item has-treeview">
                <a class="nav-link">
                 <app-icons name="coachee" [width]="20" [height]="20" color="#377FEB"></app-icons>
                </a>
              </li>
            </ul>
          </div>
          <div class="section">
            <div class="menu-head">
              <p class="dots">...</p>
            </div>

            <ul
              class="nav nav-pills nav-sidebar flex-column"
              data-widget="treeview"
              data-accordion="false"
            >
              <li class="nav-item has-treeview">
                <a class="nav-link">
                 <app-icons name="evaluation" [width]="20" [height]="20" color="#377FEB"></app-icons>
                </a>
              </li>
              <li class="nav-item has-treeview">
                <a class="nav-link">
                 <app-icons name="labels" [width]="20" [height]="20" color="#377FEB"></app-icons>
                </a>
              </li>
              <li class="nav-item has-treeview">
                <a class="nav-link">
                 <app-icons name="calls" [width]="20" [height]="20" color="#377FEB"></app-icons>
                </a>
              </li>
            </ul>
          </div>
          <div class="section">
            <div class="menu-head">
              <p class="dots">...</p>
            </div>

            <ul
              class="nav nav-pills nav-sidebar flex-column"
              data-widget="treeview"
              data-accordion="false"
            >
              <li class="nav-item has-treeview">
                <a class="nav-link">
                 <app-icons name="calls" [width]="20" [height]="20" color="#377FEB"></app-icons>
                </a>
              </li>
              <li class="nav-item has-treeview">
                <a class="nav-link">
                 <app-icons name="groupUser" [width]="20" [height]="20" color="#377FEB"></app-icons>
                </a>
              </li>
              <li class="nav-item has-treeview">
                <a class="nav-link">
                 <app-icons name="settings" [width]="20" [height]="20" color="#377FEB"></app-icons>
                </a>
              </li>
            </ul>
          </div>
        </nav>
        <!-- /.sidebar-menu -->
      </div>
    </div>
    <!-- /.sidebar end -->
  </aside>
</div>
